import type { AssetFamilyContributor } from '~/modules/artist-roster/lib/types';

import { getContributorsByRole } from '../utils';
import { ContributorLink } from './ContributorLink';

interface ContributorLinksProps {
  contributors?: AssetFamilyContributor[];
  type?: 'PRIMARY_ARTIST' | 'FEATURED_ARTIST';
}

export const noContributorsText = '--';

export function ContributorLinks({
  contributors = [],
  type = 'PRIMARY_ARTIST',
}: ContributorLinksProps) {
  const contributorsByRole = getContributorsByRole(contributors, type);

  if (!contributorsByRole.length) {
    return <>{noContributorsText}</>;
  }

  return (
    <>
      {contributorsByRole.map((contributor, index) => (
        <ContributorLink key={index} {...{ contributor, index }} />
      ))}
    </>
  );
}

ContributorLinks.displayName = 'ContributorLinks';
